import React from "react";
import FinancialReportPage from "../Reports/FinancialReportPage";

const ReportIncomePage = () => <FinancialReportPage type="sales" />;

export default ReportIncomePage;
